import React from 'react';
import { Footer } from '@wfp/ui';
import { useDedobUser } from '../../hooks/home';


const version = import.meta.env.VITE_VERSION;

export function PageFooter() {
	const feVersion = (version || '').split('-')[0];
	const beVersion = (useDedobUser()?.version || '').split('-')[0];

	return (
		<Footer
			metaContent={`WFP OIMS ${beVersion} / DOB ${feVersion} – powered by WFP Operations Centre (OPSCEN) with the support of Global Headquarters and country offices which are responsible for the accuracy of the content.`}>
		</Footer>
	);
}